<template>
  <div>
    <div v-if="loadMultiPoint" class="md-layout md-alignment-center-center md-loading">
      <div class="md-layout-item md-layout md-alignment-center-center">
        <md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
      </div>
    </div>
    <div v-else>
      <md-content class="md-scrollbar">
        <div class="md-layout" v-for="(point, index) in parcelNumbers">
          <div class="md-layout-item md-size-10 md-pt-5">
            <img :src="`https://cdn.jon-api.com/shikaku-map/img/marker-${index + 1}.png`" width="24"/>
          </div>
          <div class="md-layout-item md-size-85">
            <md-field :class="validationParcelNumber(index)">
              <label>{{ requiredParcelNumber(index)
                  ? '地番を入力してください'
                  : [point.address.pref, point.address.city, point.address.large_section, point.address.small_section].join('') }}</label>
              <md-input v-model="point.parcel_number" autocomplete="off"></md-input>
              <span class="md-error" v-if="requiredParcelNumber(index)">{{ errors.parcel_number.required }}</span>
              <span class="md-error" v-else-if="chibanParcelNumber(index)">{{ errors.parcel_number.chiban }}</span>
              <span class="md-error" v-else-if="duplicatedParcelNumber(index)">{{ errors.parcel_number.duplicated }}</span>
            </md-field>
          </div>
        </div>
        <div class="md-layout md-alignment-center-right">
        </div>
      </md-content>
      <div class="md-layout">
        <div class="md-layout-item">
          <div class="md-layout md-alignment-center-right">
            <md-button class="md-primary md-raised" @click="submitParcelNumber()" :disabled="isDuplicateParcelNumbers() || isNotEnteredParcelNumbers() || isChibanParcelNumbers()">
              <label>次へ進む</label>
            </md-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $                     from 'jquery';
  import 'jquery-ui';
  import 'jquery-ui/themes/base/all.css';
  import 'jquery-ui/ui/widgets/dialog';
  import 'jquery-ui/ui/widgets/resizable';
  import {validationMixin}     from "vuelidate";
  import CommonMixin           from "../../../mixins/commonMixin";
  import LoadingSpinnerOverlay from "../../LoadingSpinnerOverlay";
  import Draggabilly           from "draggabilly";
  import Validation            from "../../../modules/validation";
  import Common                from "../../../modules/common";

  const WIDTH  = '450';
  const HEIGHT = '300';
  export default {
    name      : 'MultiPointConfirmDialog',
    props     : {
      loadMultiPoint             : {
        type   : Boolean,
        default: false,
      },
      showMultiPointConfirmDialog: {
        type   : Boolean,
        default: false,
      },
      mapInit                    : {
        type   : Object,
        default: null,
      },
    },
    mixins    : [validationMixin, CommonMixin],
    components: {LoadingSpinnerOverlay},
    data      : () => ({
      parcelNumbers: [],
      errors: {
        parcel_numbers : [],
        parcel_number: {
          required  : Validation.errorMessage(Validation.rules.required, 'parcelNumber'),
          chiban    : Validation.errorMessage(Validation.rules.chiban, 'parcelNumber'),
          duplicated: Validation.errorMessage(Validation.rules.duplicated, 'parcelNumber'),
        },
      },
    }),
    mounted() {
      const self = this;
      $(this.$el).dialog({
        classes  : {
          'ui-dialog': 'ui-dialog-parcel',
        },
        draggable: false,
        resizable: false,
        width    : WIDTH,
        maxWidth : WIDTH,
        maxHeight: HEIGHT,
        minHeight: HEIGHT / 2,
        appendTo : '#app-content',
        close    : function () {
          self.close();
        },
      });
      this.changePosition();
      new Draggabilly('.ui-dialog-parcel', {
        handle     : '.ui-dialog-title',
        containment: '#app-content',
      });
      if (this.mapInit && this.mapInit.dataMultiPoints) {
        this.getFormDataPoint();
      }
    },
    watch     : {
      showMultiPointConfirmDialog: function () {
        if (this.showMultiPointConfirmDialog) {
          this.changePosition();
          $(this.$el).dialog('open');
        } else {
          this.parcelNumbers = [];
          this.close();
        }
      },
      loadMultiPoint             : function () {
        const self = this;
        if (!self.loadMultiPoint && self.mapInit && self.mapInit.dataMultiPoints) {
          self.getFormDataPoint();
          self.adjustDialogSize();
        }
      },
    },
    methods   : {
      /**
       *
       */
      close() {
        $(this.$el).dialog('close');
        this.$emit('closed');
        $('.ui-dialog-parcel').remove();
      },
      /**
       *
       */
      changePosition() {
        $(this.$el).dialog('option', 'position', {my: 'center', at: 'center', of: '#app-content'});
      },
      /**
       * 地番が重複しているか
       * @return boolean
       */
      isDuplicateParcelNumbers() {
        let parcelNumbers  = [];
        this.mapInit.dataMultiPoints.map(point => {
          const parcelNumber = Common.normalizeNumberAndHyphen(point.parcel_number);
          if (!parcelNumbers.includes(parcelNumber)) {
            parcelNumbers.push(parcelNumber);
          }
        });
        return this.mapInit.dataMultiPoints.length - parcelNumbers.length !== 0;
      },
      /**
       * 地番の形式が正しいか
       * @return boolean
       */
      isChibanParcelNumbers() {
        return this.mapInit.dataMultiPoints.filter(value => {
          return ! Validation.chiban(value.parcel_number);
        }).length > 0;
      },
      /**
       * 地番が未入力か
       * @return boolean
       */
      isNotEnteredParcelNumbers() {
        return this.mapInit.dataMultiPoints.filter(value => {
          return value.parcel_number === null || value.parcel_number.length === 0;
        }).length > 0;
      },
      /**
       *
       */
      submitParcelNumber() {
        if (this.isDuplicateParcelNumbers()) {
          return;
        }
        this.parcelNumbers = this.parcelNumbers.map((value, index) => {
          value.parcel_number = Common.normalizeNumberAndHyphen(value.parcel_number);
          return value;
        });
        $(this.$el).dialog('close');
        this.$emit('multiPointConfirmed', this.parcelNumbers);
      },
      /**
       *
       */
      getFormDataPoint() {
        const self         = this;
        self.parcelNumbers = [];
        let parcelNumbers  = [];
        self.mapInit.dataMultiPoints.map(point => {
          parcelNumbers.push(point.parcel_number);
          self.parcelNumbers.push(point);
        });
      },
      /**
       * ダイアログサイズを選択された地点数に応じて調整する
       */
      adjustDialogSize() {
        const appHeight             = $('#app-content').height();
        const expectListHeight      = this.parcelNumbers.length * 76 + 116;
        const displayableListHeight = (expectListHeight >= appHeight - 100) ? appHeight - 100 : expectListHeight;
        $(this.$el).dialog('option', 'maxHeight', appHeight);
        $(this.$el).dialog('option', 'minHeight', displayableListHeight);
        $(this.$el).dialog('option', 'position', 'center');
      },
      /**
       * 地番の入力確認
       * @param currentIndex
       * @returns {array}
       */
      validationParcelNumber(currentIndex) {
        return {
          'md-invalid': this.duplicatedParcelNumber(currentIndex) || this.requiredParcelNumber(currentIndex) || this.chibanParcelNumber(currentIndex)
        };
      },
      /**
       * 地番の入力が重複しているか
       * @param currentIndex
       * @returns {boolean}
       */
      duplicatedParcelNumber(currentIndex) {
        const currentValue = this.parcelNumbers[currentIndex];
        const errors       = this.parcelNumbers.filter((value, index) => {
          if (index === currentIndex) {
            return false;
          }
          if (value.v1_code !== currentValue.v1_code ||
              Common.normalizeNumberAndHyphen(value.parcel_number) !== Common.normalizeNumberAndHyphen(currentValue.parcel_number)) {
            return false;
          }
          return true;
        });
        return errors.length > 0;
      },
      /**
       * 地番の形式が正しいか
       * @param currentIndex
       * @returns {boolean}
       */
      chibanParcelNumber(currentIndex) {
        const currentValue = this.parcelNumbers[currentIndex];
        return ! Validation.chiban(currentValue.parcel_number);
      },
      /**
       * 地番の入力がされているか
       * @param currentIndex
       * @returns {boolean}
       */
      requiredParcelNumber(currentIndex) {
        const currentValue = this.parcelNumbers[currentIndex];
        return currentValue.parcel_number === null || currentValue.parcel_number.length === 0;
      }
    },
  }
</script>

<style lang="scss" scoped>
  .ui-widget-content {
    overflow: hidden !important;
  }

  .md-content {
    height: auto;
    max-height: calc(100vh - 300px);
    margin-bottom: 10px;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    -webkit-transform: translate3d(0, 0, 0);
  }

  ::v-deep(.md-loading) {
    min-height: 235px;
  }

  .md-pt-5 {
    padding-top: 5px;
  }

  .md-error {
    color: #ff5252;
    opacity: 1;
    padding-top: 4px;
  }
</style>
